import React from 'react'

export default function Footer() {
    return (
        <div id="footer" className="">
            <div className="custom-shape-divider-bottom-1631631681">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" class="shape-fill"></path>
                </svg>
            </div>
            <div className="bg-[#13131A] flex flex-col items-center">
                <a href="https://github.com/Jintumoni" target="_blank" rel="noreferrer">
                    <img src="/cat.png" alt="cat photo" className="flex mb-3 lg:hidden w-8 h-8 hover:scale-110 transition-all cursor-pointer" />
                </a>
                <p className=" flex justify-center text-black-100 p-2 text-lg mb-4">Designed and Created by <span className="invisible">x</span><span className="text-green-300 italic">Jintu Kalita</span></p>
            </div>
        </div>
    )
}
